<template>
	<div>
		<Header :isHome="false"></Header>
		
		<div class="container" v-if="defparams && data">
			<div class="news row">
				<div class="news-left col-8">
					<div class="news-top">
						<span style="cursor: pointer;" class="line-title" @click="toHome">Home</span><span class="news-top-icon">></span>
						<span style="cursor: pointer;" class="line-title" @click="toNewsmain">Information</span><span class="news-top-icon">></span>
						<span>{{list[defparams.title].title}}</span>
					</div>
					<div style="margin-top: 1rem;" class="news-title">
						<img src="../../assets/imgs/news/news-title-bg.png" class="news-title-bg">
						{{list[defparams.title].title}}
					</div>
					<div style="display: flex;flex-wrap: nowrap;width: 100%;overflow: scroll;" class="noscrollbar" ref="wrapper">
						<div v-for="(item, index) in list[defparams.title].item" :key="index" style="cursor: pointer;">
							<div class="btn-normal" :class="{ 'btn-normal-active': index == defparams.item }" style="cursor: pointer;width: max-content;" @click="changeitem(index, item.id)">{{item.name}}</div>
						</div>
					</div>
					<div style="display: flex;flex-direction: column;margin-top: 1rem;">
						<div class="news-left-box hover-up-2 transition-normal" v-for="(item, index2) in data.items" :key="index2" style="cursor: pointer;" @click="tonewsdetail(item.id)">
							<div class="news-left-box-img" :style="{backgroundImage: 'url('+item.coverImage+')'}"></div>
							<div class="news-left-box-r">
								<div style="display: flex;flex-direction: column;flex:1">
									<div class="news-left-box-r-title text-hover" v-text="item.title"></div>
									<div class="news-left-box-r-dec" v-show="item.subTitle" v-text="item.subTitle"></div>
									<div class="news-left-box-r-tags">
										<div v-for="(tag, index3) in item.tags" :key="index3" style="margin-right: 0.5rem;" :style="{color: colorlist[index3]}" v-text="tag.name"></div>
									</div>
								</div>
							
								<div style="display: flex;align-items: center;margin-top: 0.5rem;">
									<!-- <img src="../../assets/imgs/news/icon-time.png" class="news-left-box-r-icon"> -->
									<span class="news-left-box-r-icontext" v-text="format(item.createdAt)"></span>
									<img src="../../assets/imgs/news/icon-eyes.svg" class="news-left-box-r-icon">
									<span class="news-left-box-r-icontext" v-text="item.browseCount"></span>
									<img :src="item.collected?require('../../assets/imgs/news/icon-star-light.svg'):require('../../assets/imgs/news/icon-star.svg')" class="news-left-box-r-icon">
									<span class="news-left-box-r-icontext" v-text="item.collectionCount"></span>
									<img :src="item.liked?require('../../assets/imgs/news/icon-like-light.svg'):require('../../assets/imgs/news/icon-like.svg')" class="news-left-box-r-icon">
									<span class="news-left-box-r-icontext" v-text="item.likeCount"></span>
									<!-- <span class="news-left-box-r-time">News | mar.29,2023</span> -->
								</div>
							</div>
						</div>
					</div>
					<pagination
					    :page="page"
					    :page-size="perPage"
					    :total="data.total||0"
					    :on-page-change="onPage"
					    :pageSizeList="[]"
					    class="pagi page-content"
						style="margin-bottom: 3rem;"
					/>
				</div>
				<Hotnews></Hotnews>
			</div>
		</div>
		<Footer></Footer>
	</div>
</template>

<script>
	
			// import axios from 'axios'
			import Header from '/src/components/header.vue'
			import Footer from '/src/components/footer.vue'
			import Hotnews from '/src/components/news/hotnews.vue'
			// import {baseUrl} from '../../assets/js/public.js'
			import Pagination from '@/components/pagination.vue';
			import Drag from '../../utils/move.js'
			export default {
				data() {
					return {
						defparams: {
							title: 0,
							item: 0,
						},
						list:[
							{
								title: 'Industry Information',
								id:1,
								item: [
									{name:'Sanitary care', id:2},
									{name:'Tourism care', id:3},
									{name:'Pet care', id:5},
									{name:'Food care', id:4},
									{name:'Home care', id:6},
								]
							},
							{
								title: 'Events',
								id:7,
								item: [
									{name:' Latest News On GCI', id:8},
									{name:'Exhibitions & Forums', id:9},
								]
							},
							{
								title: 'GCI Insights',
								id:10,
								item: []
							},
						],
						colorlist:['#01A587', '#8D66F8', '#ED532B', '#D8BE50', '#52A5F7'],
						data: null,
						page: 1,
						perPage: 10
					}
				},
				props:{
				},
				components: {
					Header,
					Footer,
					Hotnews,
					Pagination,
				},
				filters: {
				},
				methods: {
					format(d){
						var date = new Date(d);
						var y = date.getFullYear();
						var m = date.getMonth() + 1;
						m = m < 10 ? ('0' + m) : m;
						var d = date.getDate();
						d = d < 10 ? ('0' + d) : d;
						var h = date.getHours();
						h = h < 10 ? ('0' + h) : h;
						var min = date.getMinutes();
						min = min < 10 ? ('0' + min) : min;
						var s = date.getSeconds();
						s = s < 10 ? ('0' + s) : s;
						return y + '-' + m + '-' + d + ' ' + h + ':' + min + ':' + s;
					},
					getData(){
						let classifyId = this.list[this.defparams.title].item.length>0?this.list[this.defparams.title].item[this.defparams.item].id:this.list[this.defparams.title].id
						// let perPage = 20, page = 1
						this.request({
							method: 'get',
							url: '/gci/article/list?classifyId=' + classifyId + '&page=' + this.page + '&perPage=' + this.perPage,
						}).then(res => {
							// this.$bus.$emit('totop', true)
							this.data = res.data
							this.$bus.$emit('loading', false)
							console.info('newslist',this.data)
							this.$nextTick(()=>{
								new Drag(this.$refs.wrapper);
							})
						}).catch(error => {
							console.error(error.response)
						})
					},
					// 分页
					onPage(pageNow) {
						console.log('pageNow', pageNow);
						this.page = pageNow;
						this.getData()
					},
					changeitem(index, id){
						this.$bus.$emit('noloading', true)
						this.defparams.item = index
						this.page = 1
						this.getData()
					},
					toHome(){
						this.$router.push({name:'home'})
					},
					toNewsmain(){
						this.$router.push({name:'newsmain'})
					},
					tonewsdetail(id){
						this.$router.push({name:'newsdetail',query:{id:id,title:this.defparams.title,item:this.defparams.item}})
					}
				},
				created() {
					this.$bus.$emit('loading', true)
				},
				mounted() {
					// this.defparams = this.$route.params
					this.defparams = JSON.parse(localStorage.getItem('newslist'))
					console.info(this.defparams)
					this.getData()
				}
			}
</script>

<style scoped lang="scss">
	.news{
		display: flex;
		margin-top: 7rem;
		.news-left{
			display: flex;flex-direction: column;
			.news-top{
				color: #1C1F24;
				font-size: 0.9rem;
				font-weight: 500;
				&-icon{
					margin: 0 0.5rem;
				}
			}
			.news-l-item{
				background-color: #fff;
				color: #333;
				font-size: 0.9rem;
				font-weight: bold;
				// padding: 0.5rem;
				border-radius: 0.2rem;
				margin-right: 1rem;
				border: 1px solid #E0E0E0;;
				margin-top: 1rem;
				display: flex;align-items: center;justify-content: center;
				// width: 6rem;
				// height: 2rem;
				padding: 0.5rem 1rem;
			}
			.news-l-item-active{
				background-color: #31ffda;color: #333;
				border:1px solid transparent
			}
			
			.news-left-box{
				background: #FFFFFF;
				// box-shadow: 0px 4px 2.5rem -2px rgba(0,0,0,0.08);
				// border: 1px solid #E2E2E2;
				border-radius: 1rem;
				padding: 1rem;
				margin-bottom: 1rem;
				display: flex;
				align-items: center;
				&-img{
					min-width: 10rem;min-height: 10rem;border-radius: 0.2rem;
					background-size: cover;background-repeat: no-repeat;background-position: center center;
				}
				&-r{
					display: flex;flex-direction: column;margin-left: 1rem;width: 100%;height: 100%;
					&-title{
						font-size: 1.2rem;
						font-weight: bold;
						color: #333;
						
						display: -webkit-box;
						-webkit-line-clamp: 2;
						-webkit-box-orient: vertical;
						text-overflow: ellipsis;
						overflow: hidden;
					}
					&-dec{
						font-size: 0.7rem;
						font-weight: 400;
						color: #666;
						margin-top: 0.5rem;
					}
					&-tags{
						font-size: 0.7rem;
						margin-top: 0.5rem;
						display: flex;
						flex-wrap: wrap;
					}
					&-icon{
						width: 1.2rem;height: 1.2rem;margin-right: 0.2rem;
					}
					&-icontext{
						font-size: 0.7rem;color: #999;margin-right: 1rem;
					}
					&-time{
						font-size: 0.7rem;
						color: #999;
						font-weight: 400;
					}
				}
			}
		}
	}
	.news-left-box:hover{
		box-shadow: 0px 4px 2rem -2px rgba(0,0,0,0.08);
	}
	.news-title{
		height: 3rem;
		font-size: 1.5rem;
		font-weight: bold;
		.news-title-bg{
			width: 13rem;z-index: -1;position: absolute;left: 0.5rem;top: 1rem
		}
	}
	.noscrollbar::-webkit-scrollbar{display: none;}
	.line-title:hover{
		color: #62e0c9;
	}
	@media (max-width:767px) {
		.news-left{
			min-width: 100%;
		}
		.news-left-box{
			flex-direction: column;
		}
		.news-left-box-img{
			width: 100%;
			margin-bottom: 1rem;
		}
		
		.news-left-box-r-title{
			display: -webkit-box;
			-webkit-line-clamp: 2;
			-webkit-box-orient: vertical;
			text-overflow: ellipsis;
			overflow: hidden;
		}
		.news-left-box-r-dec{
				display: -webkit-box;
				-webkit-line-clamp: 3;
				-webkit-box-orient: vertical;
				text-overflow: ellipsis;
				overflow: hidden;
		}
		.news-left-box-r-tags{
			display: none !important;
		}
		.news-title-bg{
			// top: 2rem !important
		}
	}
	
</style>